import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placeholder-loader',
  templateUrl: './placeholder-loader.component.html',
  styleUrls: ['./placeholder-loader.component.css']
})
export class PlaceholderLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
